export class ItemQuantidadeModel {

    public nome: string;

    public quantidade: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/item-quantidade.model.ts